import { render } from "./PinnedArtworks.vue?vue&type=template&id=b5092126&scoped=true"
import script from "./PinnedArtworks.vue?vue&type=script&lang=js"
export * from "./PinnedArtworks.vue?vue&type=script&lang=js"

import "./PinnedArtworks.vue?vue&type=style&index=0&id=b5092126&scoped=true&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5092126"]])

export default __exports__